module.exports = __webpack_public_path__ + "files/5e82d629c6cc28ed30108da844ff7bad.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature-2.png
// module id = 1373
// module chunks = 59